// Fictional company "Hvylia", a regional internet provider that also rents
// home routers. Tier-1 support, chat and phone. See README.md for the schema.
export default {
  id: 'customer-support',
  occupationId: '683b01059a1e027695ece66e',
  occupationName: { en: 'Technical support specialist', ua: 'Спеціаліст технічної підтримки' },
  format: 'helpdesk',
  title: { en: 'A shift in technical support', ua: 'Зміна в технічній підтримці' },
  tagline: {
    en: 'A fibre cut, an exam in forty minutes and a customer who wants the whole month back',
    ua: 'Обрив оптики, іспит за сорок хвилин і клієнтка, яка хоче повернути гроші за весь місяць'
  },
  minutes: 10,
  intro: {
    en: 'You work tier-1 support at Hvylia, a regional internet provider with 40 000 subscribers and its own line of rented routers. Your shift is chat and phone, 09:00 to 18:00. Tier 2 sits in the next room and takes only what tier 1 cannot solve.',
    ua: 'Ти на першій лінії підтримки у Hvylia, регіонального інтернет-провайдера на 40 000 абонентів із власними роутерами в оренду. Твоя зміна — чат і телефон, з 09:00 до 18:00. Друга лінія сидить у сусідній кімнаті й бере лише те, чого перша не вирішила.'
  },
  goal: {
    en: 'Keep the SLA green and the customers calmer than when they called',
    ua: 'Тримати SLA зеленим, а клієнтів — спокійнішими, ніж коли вони подзвонили'
  },
  kpis: [
    {
      key: 'resolution',
      label: { en: 'First-contact resolution', ua: 'Вирішення з першого разу' },
      start: 55
    },
    {
      key: 'csat',
      label: { en: 'Customer satisfaction', ua: 'Задоволеність клієнтів' },
      start: 60
    },
    { key: 'sla', label: { en: 'SLA', ua: 'SLA' }, start: 60 }
  ],
  competencies: [
    {
      key: 'diagnosis',
      label: { en: 'Diagnosis', ua: 'Діагностика' },
      skill: {
        _id: '686282c1aa8e5a92e3bc1514',
        name: 'Діагностика та усунення несправностей обладнання'
      }
    },
    {
      key: 'empathy',
      label: { en: 'Empathy', ua: 'Емпатія' },
      skill: { _id: '686282c1aa8e5a92e3bc133f', name: 'Емпатія' }
    },
    {
      key: 'priorities',
      label: { en: 'Prioritisation', ua: 'Пріоритизація' },
      skill: { _id: '686282c1aa8e5a92e3bc140a', name: 'Управління часом і розстановка пріоритетів' }
    },
    {
      key: 'accuracy',
      label: { en: 'Accuracy', ua: 'Точність' },
      skill: { _id: '686282c1aa8e5a92e3bc1408', name: 'Точність' }
    },
    {
      key: 'policy',
      label: { en: 'Policy and data', ua: 'Правила та дані' },
      skill: { _id: 'b71f1d2c99595085217a13e0', name: 'Захист персональних даних' }
    }
  ],
  people: [
    {
      key: 'student',
      name: { en: 'Maksym', ua: 'Максим' },
      role: { en: 'Customer, student', ua: 'Клієнт, студент' },
      initials: 'MA',
      color: '#e25510'
    },
    {
      key: 'halyna',
      name: { en: 'Halyna', ua: 'Галина' },
      role: { en: 'Customer', ua: 'Клієнтка' },
      initials: 'HA',
      color: '#d5921b'
    },
    {
      key: 'lead',
      name: { en: 'Oleh', ua: 'Олег' },
      role: { en: 'Shift lead, tier 2', ua: 'Старший зміни, друга лінія' },
      initials: 'OL',
      color: '#30b0c7'
    }
  ],
  steps: [
    {
      type: 'queue',
      id: 's1',
      at: '09:00',
      comp: ['priorities', 'diagnosis'],
      traits: ['R', 'S'],
      text: {
        en: 'Shift starts. Four tickets are already waiting. Open them in the order you think is right and pick a first reply for each.',
        ua: 'Початок зміни. Чотири тікети вже чекають. Відкрий їх у тому порядку, який вважаєш правильним, і обери першу відповідь на кожен.'
      },
      tickets: [
        {
          id: 't1',
          from: { en: 'Café "Lavanda", business account', ua: 'Кав’ярня «Лаванда», бізнес-акаунт' },
          urgency: 3,
          sla: { en: '30 min', ua: '30 хв' },
          subject: {
            en: 'No internet, card terminal offline',
            ua: 'Немає інтернету, термінал не працює'
          },
          body: {
            en: 'Internet dropped at 08:50. The card terminal is down and we are losing every sale. Router lights: power green, internet red. Business line, 30-minute SLA.',
            ua: 'Інтернет зник о 08:50. Термінал не працює, втрачаємо кожен продаж. На роутері: живлення зелене, інтернет червоний. Бізнес-лінія, SLA 30 хвилин.'
          },
          options: [
            {
              text: {
                en: 'Check the line status and outages for their address first; if the port is up, walk them through a router power cycle. If nothing changes in 10 minutes, escalate to tier 2 with the business tag.',
                ua: 'Спершу перевірити стан лінії та аварії за їхньою адресою; якщо порт живий, провести перезавантаження роутера. Якщо за 10 хвилин нічого не зміниться, ескалювати на другу лінію з бізнес-міткою.'
              },
              q: 'best',
              fx: { sla: 4, resolution: 3 },
              fb: {
                en: 'Line status before router steps saves ten minutes when the fault is outside the café. The 10-minute limit keeps you inside a 30-minute SLA.',
                ua: 'Стан лінії перед кроками з роутером економить десять хвилин, коли поломка поза кав’ярнею. Ліміт у 10 хвилин тримає тебе в межах 30-хвилинного SLA.'
              }
            },
            {
              text: {
                en: 'Start with the standard script: power cycle the router, check the cable, wait two minutes, then test. Business or not, most red lights are fixed this way.',
                ua: 'Почати зі стандартного скрипта: перезавантажити роутер, перевірити кабель, зачекати дві хвилини, перевірити. Бізнес чи ні, більшість червоних індикаторів лікуються саме так.'
              },
              q: 'ok',
              fx: { sla: -1 },
              fb: {
                en: 'Often works, but you skipped the one check that tells you whether the problem is theirs or yours. If the port is down, the script wastes a third of the SLA.',
                ua: 'Часто спрацьовує, але ти пропустив єдину перевірку, яка каже, чия це проблема. Якщо порт лежить, скрипт з’їдає третину SLA.'
              }
            },
            {
              text: {
                en: "Explain that the card terminal is the bank's equipment, not ours, and suggest they call the bank's support line while the internet recovers on its own.",
                ua: 'Пояснити, що термінал — обладнання банку, а не наше, і порадити зателефонувати в підтримку банку, поки інтернет відновиться сам.'
              },
              q: 'bad',
              fx: { csat: -8, sla: -4 },
              fb: {
                en: 'The terminal is down because the internet is down, which is exactly your problem. You sent a paying business customer to the wrong queue.',
                ua: 'Термінал не працює, бо не працює інтернет, а це саме твоя проблема. Ти відправив платного бізнес-клієнта не в ту чергу.'
              }
            }
          ]
        },
        {
          id: 't2',
          from: { en: 'Oleksandr P.', ua: 'Олександр П.' },
          urgency: 3,
          sla: { en: '1 h', ua: '1 год' },
          subject: {
            en: 'Internet down, work call in 20 minutes',
            ua: 'Немає інтернету, робочий дзвінок за 20 хвилин'
          },
          body: {
            en: 'No connection since 08:40. I work from home and have a client call at 09:20. The router shows a red light. Already restarted it twice.',
            ua: 'З 08:40 немає з’єднання. Працюю з дому, о 09:20 дзвінок із клієнтом. На роутері червоний індикатор. Уже перезавантажував двічі.'
          },
          options: [
            {
              text: {
                en: 'Check for an outage at his address and tell him what you see, with a realistic time. For the call, suggest a phone hotspot now, and promise a message when the line is back.',
                ua: 'Перевірити аварію за його адресою і назвати реальний час. Для дзвінка порадити роздати інтернет із телефона і пообіцяти повідомлення, коли лінія оживе.'
              },
              q: 'best',
              fx: { csat: 4, resolution: 2 },
              fb: {
                en: 'He restarted twice, so a third restart insults him. A real ETA plus a workaround for the next 20 minutes is the whole value you can add.',
                ua: 'Він перезавантажував двічі, тож третє перезавантаження його образить. Реальний час плюс обхідний шлях на найближчі 20 хвилин — уся цінність, яку ти можеш додати.'
              }
            },
            {
              text: {
                en: 'Book a technician for tomorrow morning as a precaution and ask him to try the router on a different socket in the meantime.',
                ua: 'Про всяк випадок записати техніка на завтра зранку і попросити тим часом увімкнути роутер в іншу розетку та перевірити кабель.'
              },
              q: 'ok',
              fx: { sla: -2 },
              fb: {
                en: 'A technician visit for a possible area outage ties up a slot someone else needs. You also said nothing about the call he is about to miss.',
                ua: 'Виклик техніка на ймовірну аварію в районі займає слот, потрібний комусь іншому. Про дзвінок, який він ось-ось пропустить, ти теж нічого не сказав.'
              }
            },
            {
              text: {
                en: 'Ask him to restart the router once more and wait 30 minutes; if nothing changes, write again and the ticket will be passed on.',
                ua: 'Попросити ще раз перезавантажити роутер і зачекати 30 хвилин; якщо нічого не зміниться, написати знову, і тікет передадуть далі.'
              },
              q: 'bad',
              fx: { csat: -7, resolution: -3 },
              fb: {
                en: 'You asked for the thing he has already done twice, and "write again" means he starts from zero in the queue. His call is in 20 minutes, not 30.',
                ua: 'Ти попросив зробити те, що він уже робив двічі, а «напишіть знову» означає, що він стає в чергу з нуля. Дзвінок у нього за 20 хвилин, а не за 30.'
              }
            }
          ]
        },
        {
          id: 't3',
          from: { en: 'Nina K.', ua: 'Ніна К.' },
          urgency: 2,
          sla: { en: '4 h', ua: '4 год' },
          subject: { en: 'Wi-Fi slow in the bedroom', ua: 'Повільний Wi-Fi у спальні' },
          body: {
            en: 'Next to the router the speed is fine, in the bedroom video keeps buffering. Two walls between them. Is there something wrong with my tariff?',
            ua: 'Біля роутера швидкість нормальна, у спальні відео постійно підвантажується. Між ними дві стіни. Щось не так із моїм тарифом?'
          },
          options: [
            {
              text: {
                en: 'Explain it is coverage, not the tariff: two walls eat the signal. Offer the mesh extender from the price list and one free tip, moving the router out from behind the TV.',
                ua: 'Пояснити, що річ у покритті, а не в тарифі: дві стіни з’їдають сигнал. Запропонувати mesh-розширювач з прайсу і одну безкоштовну пораду: прибрати роутер з-за телевізора.'
              },
              q: 'best',
              fx: { resolution: 4, csat: 3 },
              fb: {
                en: 'She asked the wrong question and you answered the right one. A free tip before a paid product is what makes the product feel honest.',
                ua: 'Вона поставила не те питання, а ти відповів на правильне. Безкоштовна порада перед платним продуктом — те, що робить продукт чесним.'
              }
            },
            {
              text: {
                en: 'Offer a paid technician visit to measure the signal in every room and recommend equipment. It is the thorough way to solve coverage.',
                ua: 'Запропонувати платний виїзд техніка, щоб заміряти сигнал у кожній кімнаті й порадити обладнання. Це ґрунтовний спосіб вирішити питання покриття.'
              },
              q: 'ok',
              fx: { csat: -1 },
              fb: {
                en: 'Thorough, but a paid visit for a problem you can diagnose from "two walls" feels like an upsell. Give the answer first, the visit second.',
                ua: 'Ґрунтовно, але платний виїзд для проблеми, яку видно зі слів «дві стіни», виглядає як нав’язування. Спершу відповідь, потім виїзд.'
              }
            },
            {
              text: {
                en: 'Suggest moving to the faster tariff: twice the bandwidth usually fixes buffering, and the upgrade is free for the first month.',
                ua: 'Запропонувати перейти на швидший тариф: удвічі більша швидкість зазвичай прибирає підвантаження, а перший місяць переходу безкоштовний.'
              },
              q: 'bad',
              fx: { csat: -6, resolution: -4 },
              fb: {
                en: 'Bandwidth at the router does not pass through walls. She will pay more, see no change, and come back angrier.',
                ua: 'Швидкість на роутері крізь стіни не проходить. Вона заплатить більше, не побачить змін і повернеться злішою.'
              }
            }
          ]
        },
        {
          id: 't4',
          from: { en: 'Serhii D.', ua: 'Сергій Д.' },
          urgency: 1,
          sla: { en: '24 h', ua: '24 год' },
          subject: { en: 'Invoice copy for last month', ua: 'Копія рахунку за минулий місяць' },
          body: {
            en: 'My employer reimburses home internet. Could you send me the invoice for last month as a PDF?',
            ua: 'Роботодавець компенсує домашній інтернет. Можете надіслати рахунок за минулий місяць у PDF?'
          },
          options: [
            {
              text: {
                en: 'Send the PDF from the billing system now and show him where to download it himself in the account next time.',
                ua: 'Надіслати PDF із білінгу зараз і показати, де наступного разу завантажити його самому в особистому кабінеті.'
              },
              q: 'best',
              fx: { resolution: 3, sla: 1 },
              fb: {
                en: 'Two minutes now and zero tickets next month. Teaching the self-service path is the only way a tier-1 queue ever gets shorter.',
                ua: 'Дві хвилини зараз і нуль тікетів наступного місяця. Показати шлях самообслуговування — єдиний спосіб, яким черга першої лінії стає коротшою.'
              }
            },
            {
              text: {
                en: 'Forward the request to billing; invoices are their domain and they will send it within the 24-hour SLA.',
                ua: 'Переслати запит у білінг; рахунки — їхня зона, і вони надішлють у межах 24-годинного SLA.'
              },
              q: 'ok',
              fx: { sla: -1 },
              fb: {
                en: 'Inside the SLA, but a two-minute task now travels through two queues and one more person.',
                ua: 'У межах SLA, але двохвилинна справа тепер мандрує двома чергами й ще однією людиною.'
              }
            },
            {
              text: {
                en: 'Tell him invoices are issued in person at the service centre with a passport, Mon–Fri 09:00–18:00.',
                ua: 'Сказати, що рахунки видають особисто в сервісному центрі за паспортом, Пн–Пт з 09:00 до 18:00.'
              },
              q: 'bad',
              fx: { csat: -5 },
              fb: {
                en: 'An invoice copy is a button in the billing system. You sent a customer across town for a PDF.',
                ua: 'Копія рахунку — кнопка в білінгу. Ти відправив клієнта через усе місто по PDF.'
              }
            }
          ]
        }
      ]
    },
    {
      type: 'chat',
      id: 's2',
      at: '09:50',
      comp: ['empathy', 'diagnosis'],
      traits: ['S', 'E'],
      messages: [
        {
          from: 'student',
          text: {
            en: 'Your internet is DOWN again. My exam starts at 10:30, online, with a camera. If I fail it, it is on you. Do something now, not "we are aware of the issue".',
            ua: 'Ваш інтернет ЗНОВУ не працює. О 10:30 у мене іспит, онлайн, з камерою. Якщо я його завалю, це на вас. Зробіть щось зараз, а не «ми знаємо про проблему».'
          }
        },
        {
          from: 'lead',
          text: {
            en: '(internal) Fibre cut in the Pivdennyi district, about 1 200 subscribers. Crew on site, ETA 11:30. Script update coming.',
            ua: '(внутрішнє) Обрив оптики в Південному районі, близько 1 200 абонентів. Бригада на місці, орієнтовно до 11:30. Оновлення скрипта буде.'
          }
        }
      ],
      prompt: {
        en: 'Maksym is in the Pivdennyi district. What do you reply?',
        ua: 'Максим у Південному районі. Що відповідаєш?'
      },
      options: [
        {
          text: {
            en: 'Tell him the truth: a fibre cut, repair by about 11:30, so not before the exam. Then the plan: phone hotspot now, and a written outage confirmation for his university from you within 10 minutes.',
            ua: 'Сказати правду: обрив оптики, ремонт до 11:30, тобто не до іспиту. Далі план: роздати інтернет із телефона зараз, а за 10 хвилин — письмове підтвердження аварії для університету.'
          },
          q: 'best',
          fx: { csat: 6, resolution: 3 },
          fb: {
            en: 'He cannot have the internet, so you give him the two things you can: an honest time and paper that protects him with the examiner. Anger drops when the plan is concrete.',
            ua: 'Інтернет ти йому дати не можеш, тож даєш дві речі, які можеш: чесний час і папір, який захистить його перед екзаменатором. Злість спадає, коли план конкретний.'
          }
        },
        {
          text: {
            en: 'Apologise, explain the fibre cut and the 11:30 estimate, and say you understand how stressful this is. Offer to credit the outage hours to his account.',
            ua: 'Вибачитися, пояснити про обрив оптики й орієнтовні 11:30, сказати, що розумієш, наскільки це стресово. Запропонувати зарахувати години аварії на рахунок.'
          },
          q: 'ok',
          fx: { csat: 1 },
          fb: {
            en: 'Honest and kind, but a credit of a few hryvnias does not help at 10:30. He needed a workaround for the next 40 minutes, not sympathy for the month.',
            ua: 'Чесно й по-людськи, але кілька гривень компенсації не допоможуть о 10:30. Йому потрібен був обхідний шлях на найближчі 40 хвилин, а не співчуття за місяць.'
          }
        },
        {
          text: {
            en: 'Walk him through the router restart and a cable check first; it is procedure, and you cannot escalate anything without the standard steps done.',
            ua: 'Спершу провести його через перезавантаження роутера і перевірку кабелю; така процедура, і без стандартних кроків ескалювати нічого не можна.'
          },
          q: 'bad',
          fx: { csat: -8 },
          fb: {
            en: 'You know it is a fibre cut. Fifteen minutes of theatre with the router eats the time he had to find another connection, and he can tell you are reading a script.',
            ua: 'Ти знаєш, що це обрив оптики. П’ятнадцять хвилин театру з роутером з’їдають час, який у нього був, щоб знайти інше з’єднання, і він чує, що ти читаєш скрипт.'
          }
        },
        {
          text: {
            en: "Tell him it is not the company's fault: a road crew cut the cable, repairs are under way, and the exam schedule is between him and his university.",
            ua: 'Сказати, що компанія не винна: кабель перебили дорожники, ремонт уже триває, а розклад іспиту — це питання між ним і його університетом.'
          },
          q: 'bad',
          fx: { csat: -10 },
          fb: {
            en: 'True, and useless. He hears "not my problem" from the one person he could reach. Who cut the cable does not matter to someone with 40 minutes.',
            ua: 'Правда, і марна. Він чує «не моя проблема» від єдиної людини, до якої додзвонився. Тому, в кого лишилося 40 хвилин, байдуже, хто перебив кабель.'
          }
        }
      ],
      principle: {
        en: 'When you cannot fix it, give a time and a workaround.',
        ua: 'Коли не можеш полагодити, дай час і обхідний шлях.'
      }
    },
    {
      type: 'triage',
      id: 's3',
      at: '10:40',
      comp: ['priorities', 'accuracy'],
      traits: ['C', 'I'],
      text: {
        en: 'Five tickets, one of you. Order them by what you take first. Each shows its SLA and how long it has been waiting.',
        ua: 'П’ять тікетів, ти один. Розстав за тим, що береш першим. У кожного вказано SLA і скільки він уже чекає.'
      },
      items: [
        {
          id: 'biz',
          title: {
            en: 'Logistics office, 40 workstations offline',
            ua: 'Офіс логістики, 40 робочих місць без мережі'
          },
          detail: {
            en: 'Business SLA 30 min, waiting 25 min. Whole office down.',
            ua: 'Бізнес-SLA 30 хв, чекає 25 хв. Весь офіс без мережі.'
          }
        },
        {
          id: 'home',
          title: { en: 'Private customer, no internet', ua: 'Приватний клієнт, немає інтернету' },
          detail: {
            en: 'SLA 1 h, waiting 50 min. Total outage, one household.',
            ua: 'SLA 1 год, чекає 50 хв. Повна відсутність, одне домогосподарство.'
          }
        },
        {
          id: 'slow',
          title: {
            en: 'Private customer, slow speed in the evenings',
            ua: 'Приватний клієнт, повільно вечорами'
          },
          detail: {
            en: 'SLA 8 h, waiting 7 h. Connection works, speed drops after 20:00.',
            ua: 'SLA 8 год, чекає 7 год. З’єднання є, швидкість падає після 20:00.'
          }
        },
        {
          id: 'cam',
          title: {
            en: 'Shop, one of three cameras offline',
            ua: 'Магазин, одна з трьох камер офлайн'
          },
          detail: {
            en: 'Business SLA 4 h, waiting 1 h. Internet works, one camera lost connection.',
            ua: 'Бізнес-SLA 4 год, чекає 1 год. Інтернет працює, одна камера втратила зв’язок.'
          }
        },
        {
          id: 'pwd',
          title: {
            en: 'Private customer, change Wi-Fi password',
            ua: 'Приватний клієнт, змінити пароль Wi-Fi'
          },
          detail: {
            en: 'SLA 24 h, waiting 20 h. A request, not a fault.',
            ua: 'SLA 24 год, чекає 20 год. Запит, не поломка.'
          }
        }
      ],
      correctOrder: ['biz', 'home', 'slow', 'cam', 'pwd'],
      explain: {
        en: 'Order by time left on the SLA, then by impact: the office has 5 minutes and 40 people, the household 10 minutes, the slow-speed ticket 1 hour. The camera has 3 hours and the internet works. The password request has 4 hours and nothing is broken.',
        ua: 'Спочатку за часом, що лишився до SLA, потім за впливом: в офісу 5 хвилин і 40 людей, у домогосподарства 10 хвилин, у тікета зі швидкістю 1 година. У камери 3 години, і інтернет працює. У запиту про пароль 4 години, і нічого не зламано.'
      },
      fx: { ok: { sla: 6 }, fail: { sla: -5, energy: -3 } }
    },
    {
      type: 'spot',
      id: 's4',
      at: '11:20',
      comp: ['accuracy', 'empathy'],
      traits: ['C'],
      text: {
        en: 'A new colleague drafted a reply to Nina K. about her slow bedroom Wi-Fi and asked you to check it before sending. The price list says the mesh extender rents for €9 a month. The draft has 3 mistakes. Tap each one.',
        ua: 'Новий колега написав відповідь Ніні К. про повільний Wi-Fi у спальні й попросив перевірити перед відправкою. За прайсом оренда mesh-розширювача — 300 грн на місяць. У чернетці 3 помилки. Натисни на кожну.'
      },
      mock: {
        kind: 'card',
        title: { en: 'Draft reply: ticket #48213', ua: 'Чернетка відповіді: тікет №48213' },
        blocks: [
          {
            id: 'b1',
            kind: 'field',
            label: { en: 'Greeting', ua: 'Привітання' },
            value: { en: 'Good afternoon, Nina,', ua: 'Добрий день, Ніно.' }
          },
          {
            id: 'b2',
            kind: 'field',
            label: { en: 'Diagnosis', ua: 'Діагноз' },
            value: {
              en: 'The speed drops because you put the router in a bad spot, behind the TV. Two walls block the signal.',
              ua: 'Швидкість падає, бо ви поставили роутер у невдале місце, за телевізор. Дві стіни глушать сигнал.'
            },
            issue: {
              en: 'Blames the customer. Say what the signal does, not what she did wrong.',
              ua: 'Звинувачує клієнтку. Кажи, що робить сигнал, а не що вона зробила не так.'
            }
          },
          {
            id: 'b3',
            kind: 'field',
            label: { en: 'Step 1', ua: 'Крок 1' },
            value: {
              en: 'Press the WPS button on the router and on the extender to pair them.',
              ua: 'Натисніть кнопку WPS на роутері та на розширювачі, щоб їх з’єднати.'
            },
            issue: {
              en: 'Pairing comes after plugging in. In this order she presses WPS on a device that is not powered.',
              ua: 'З’єднання йде після вмикання. У цьому порядку вона тисне WPS на пристрої, який не ввімкнений.'
            }
          },
          {
            id: 'b4',
            kind: 'field',
            label: { en: 'Step 2', ua: 'Крок 2' },
            value: {
              en: 'Plug the extender into a socket halfway between the router and the bedroom and wait for the green light.',
              ua: 'Увімкніть розширювач у розетку на півдорозі між роутером і спальнею та дочекайтеся зеленого індикатора.'
            }
          },
          {
            id: 'b5',
            kind: 'field',
            label: { en: 'Step 3', ua: 'Крок 3' },
            value: {
              en: 'Connect your devices to the same network name as before.',
              ua: 'Підключіть пристрої до тієї самої мережі, що й раніше.'
            }
          },
          {
            id: 'b6',
            kind: 'line',
            label: { en: 'Price', ua: 'Ціна' },
            value: {
              en: 'Mesh extender rental: €14 a month',
              ua: 'Оренда mesh-розширювача: 450 грн на місяць'
            },
            issue: {
              en: 'The price list says €9. A wrong price in writing is a complaint next month.',
              ua: 'За прайсом 300 грн. Неправильна ціна в письмовому вигляді — скарга наступного місяця.'
            }
          },
          {
            id: 'b7',
            kind: 'note',
            label: { en: 'Closing', ua: 'Завершення' },
            value: {
              en: 'Let us know if the problem persists. Have a good day.',
              ua: 'Напишіть, якщо проблема залишиться. Гарного дня.'
            }
          },
          { id: 'b8', kind: 'button', label: { en: 'Send', ua: 'Надіслати' }, value: '' }
        ]
      },
      explain: {
        en: "The diagnosis blames her for the router's position instead of explaining coverage. Steps 1 and 2 are swapped: plug in first, pair second. The price is €14 against €9 on the price list. Greeting, step 3 and closing are fine.",
        ua: 'Діагноз звинувачує її в розташуванні роутера замість того, щоб пояснити покриття. Кроки 1 і 2 переплутані: спершу ввімкнути, потім з’єднати. Ціна 450 грн проти 300 у прайсі. Привітання, крок 3 і завершення в порядку.'
      },
      fx: { ok: { csat: 4, resolution: 3 }, fail: { csat: -4 } }
    },
    {
      type: 'choice',
      id: 's5',
      at: '12:10',
      comp: ['diagnosis', 'priorities'],
      traits: ['I', 'R'],
      text: {
        en: "A customer's connection has dropped every 20 minutes for three days. In 25 minutes on the phone you have done a restart, a firmware update and a cable check. The line diagnostics show CRC errors climbing on his port. He asks what happens next.",
        ua: 'У клієнта з’єднання рветься кожні 20 хвилин уже три дні. За 25 хвилин розмови ти зробив перезавантаження, оновлення прошивки і перевірку кабелю. Діагностика лінії показує, що на його порту ростуть помилки CRC. Він питає, що далі.'
      },
      options: [
        {
          text: {
            en: 'Escalate to tier 2 now with everything you did and the CRC numbers, and tell him who calls him back and by when. Line errors are not fixed from a script.',
            ua: 'Ескалювати на другу лінію зараз із усім, що ти зробив, і цифрами CRC, і сказати йому, хто й до котрої передзвонить. Помилки на лінії скриптом не лікуються.'
          },
          q: 'best',
          fx: { resolution: 4, sla: 3, csat: 3 },
          fb: {
            en: 'CRC errors are a physical-line problem; nothing on the router changes them. A complete handover means tier 2 starts from minute 26, not minute 1.',
            ua: 'Помилки CRC — проблема фізичної лінії; нічого на роутері їх не змінить. Повна передача означає, що друга лінія починає з 26-ї хвилини, а не з першої.'
          }
        },
        {
          text: {
            en: 'Try one more thing first, a factory reset of the router, so that tier 2 does not send it back as "tier-1 steps not done". Another 15 minutes.',
            ua: 'Спробувати ще одне: скинути роутер до заводських налаштувань, щоб друга лінія не повернула тікет як «кроки першої лінії не виконані». Ще 15 хвилин.'
          },
          q: 'ok',
          fx: { sla: -2, csat: -2 },
          fb: {
            en: 'A reset wipes his settings and does nothing for errors on the line. You spent his time protecting yourself from a bounce a good handover note would have prevented.',
            ua: 'Скидання зітре його налаштування і нічого не зробить із помилками на лінії. Ти витратив його час, захищаючись від повернення тікета, якому запобігла б гарна нотатка.'
          }
        },
        {
          text: {
            en: 'Book a technician for the first free slot, in two days, and close the ticket as "visit scheduled". A physical problem needs a physical visit.',
            ua: 'Записати техніка на перший вільний слот, через два дні, і закрити тікет як «виїзд заплановано». Фізична проблема потребує фізичного виїзду.'
          },
          q: 'bad',
          fx: { resolution: -4, csat: -4 },
          fb: {
            en: 'Tier 2 can often clear port errors remotely in ten minutes. You gave him two more days of drops and skipped the people who could have fixed it today.',
            ua: 'Друга лінія часто знімає помилки порту віддалено за десять хвилин. Ти дав йому ще два дні обривів і оминув людей, які могли полагодити сьогодні.'
          }
        },
        {
          text: {
            en: 'Ask him to monitor it for another day and call back if it continues; three days is not long, and intermittent faults often clear on their own.',
            ua: 'Попросити поспостерігати ще день і передзвонити, якщо триватиме; три дні — не так довго, а періодичні збої часто минають самі.'
          },
          q: 'bad',
          fx: { csat: -8, resolution: -3 },
          fb: {
            en: 'He already monitored it for three days and the diagnostics are in front of you. "Call back" means the next agent starts from zero.',
            ua: 'Він уже спостерігав три дні, а діагностика перед тобою. «Передзвоніть» означає, що наступний оператор почне з нуля.'
          }
        }
      ],
      principle: {
        en: 'Escalate when the data says the fix is not on your side. Hand over the data.',
        ua: 'Ескалюй, коли дані кажуть, що рішення не на твоєму боці. Передавай дані.'
      }
    },
    {
      type: 'numeric',
      id: 's6',
      at: '13:30',
      comp: ['accuracy', 'priorities'],
      traits: ['I', 'C'],
      text: {
        en: "The shift lead asks for this week's SLA figure for the morning report. Tickets resolved within SLA count; breached ones do not.",
        ua: 'Старший зміни просить цифру SLA за тиждень для ранкового звіту. Рахуються тікети, вирішені в межах SLA; прострочені — ні.'
      },
      data: [
        {
          label: { en: 'Tickets closed this week', ua: 'Закрито тікетів за тиждень' },
          value: '240'
        },
        { label: { en: 'Closed within SLA', ua: 'Закрито в межах SLA' }, value: '213' },
        { label: { en: 'Target', ua: 'Ціль' }, value: '92%' }
      ],
      question: {
        en: "What is this week's SLA compliance, in %?",
        ua: 'Яке дотримання SLA за тиждень, у %?'
      },
      answer: 88.75,
      tolerance: 0.02,
      unit: { en: '%', ua: '%' },
      hint: {
        en: 'Within-SLA tickets divided by all closed tickets, times 100.',
        ua: 'Тікети в межах SLA поділити на всі закриті й помножити на 100.'
      },
      explain: {
        en: '213 ÷ 240 = 0.8875, so 88.8%. That is 3.2 points under the 92% target, which is 8 tickets: at 92%, 221 of 240 would have had to close in time.',
        ua: '213 ÷ 240 = 0,8875, тобто 88,8%. Це на 3,2 пункту нижче за ціль 92%, тобто 8 тікетів: за 92% вчасно мали б закритися 221 із 240.'
      },
      fx: { ok: { sla: 4 }, fail: { sla: -3 } }
    },
    {
      type: 'chat',
      id: 's7',
      at: '14:30',
      comp: ['policy', 'empathy'],
      traits: ['S', 'E'],
      messages: [
        {
          from: 'halyna',
          text: {
            en: 'Last month I had no internet for three days and nobody even called. I pay €12 every month on time. I want the whole month refunded, and I want it today, or I am switching provider.',
            ua: 'Минулого місяця у мене три дні не було інтернету, і ніхто навіть не подзвонив. Я плачу 400 гривень щомісяця вчасно. Хочу повернення за весь місяць, і сьогодні, інакше міняю провайдера.'
          }
        }
      ],
      prompt: {
        en: 'Policy: outages longer than 24 hours are credited pro rata, so three days is 3/30 of the fee. Full-month refunds need a formal complaint to the service-quality team. What do you say?',
        ua: 'Правила: аварії довше 24 годин компенсуються пропорційно, тобто три дні — це 3/30 абонплати. Повернення за весь місяць — лише через офіційну скаргу до служби якості. Що кажеш?'
      },
      options: [
        {
          text: {
            en: 'Confirm the outage in the log, apologise for the silence and apply the three-day credit now, €1.20. Then say a full refund is outside your rights and offer to file the formal complaint for her.',
            ua: 'Знайти аварію в журналі, вибачитися за мовчання і одразу нарахувати 40 гривень за три дні. Потім прямо сказати, що повне повернення поза твоїми правами, і запропонувати подати за неї офіційну скаргу.'
          },
          q: 'best',
          fx: { csat: 4, resolution: 3 },
          fb: {
            en: 'She gets what she is owed immediately, the truth about the rest, and a path that does not depend on you. That is what calms a threat to leave.',
            ua: 'Вона одразу отримує те, що їй належить, правду про решту і шлях, який не залежить від тебе. Саме це гасить погрозу піти.'
          }
        },
        {
          text: {
            en: 'Put her on hold and ask the shift lead for an exception: a full-month credit to keep a long-standing customer. Let him decide, it is his call to make.',
            ua: 'Поставити на утримання і попросити у старшого зміни виняток: компенсацію за весь місяць, щоб утримати давню клієнтку. Хай вирішує він, це його рівень.'
          },
          q: 'ok',
          fx: { csat: 1, sla: -1 },
          fb: {
            en: 'Sometimes works, but she is on hold again with no explanation, and you taught her that shouting reaches a manager. The policy exists so fairness does not depend on volume.',
            ua: 'Іноді спрацьовує, але вона знову на утриманні без пояснень, а ти навчив її, що крик доходить до керівника. Правила існують, щоб справедливість не залежала від гучності.'
          }
        },
        {
          text: {
            en: 'Explain that the policy allows three days of credit and nothing more, that it is written in the contract, and that switching provider is of course her right.',
            ua: 'Пояснити, що правила дозволяють компенсацію за три дні й нічого більше, що це прописано в договорі, і що змінити провайдера — звісно, її право.'
          },
          q: 'bad',
          fx: { csat: -8 },
          fb: {
            en: 'Everything you said is true and the call ends with a cancellation. "It is in the contract" is what people hear right before they leave.',
            ua: 'Усе сказане — правда, і дзвінок закінчується розірванням договору. «Це в договорі» — те, що люди чують перед тим, як піти.'
          }
        },
        {
          text: {
            en: 'Promise the full month back to end the call on a good note; billing can sort out the paperwork later and a loyal customer is worth more than €12.',
            ua: 'Пообіцяти повернення за весь місяць, щоб закінчити дзвінок на добрій ноті; білінг розбереться з папірцями потім, а лояльна клієнтка вартує більше за 400 гривень.'
          },
          q: 'bad',
          fx: { csat: 5 },
          fb: {
            en: 'You promised money you cannot authorise. The next call is about your word, which is a worse complaint than three days of outage.',
            ua: 'Ти пообіцяв гроші, які не маєш права виділити. Наступний дзвінок буде про твоє слово, а це гірша скарга, ніж три дні без інтернету.'
          },
          later: {
            after: 1,
            note: {
              en: 'Billing rejected the full-month credit. Halyna calls back, now about a broken promise rather than an outage.',
              ua: 'Білінг відхилив компенсацію за весь місяць. Галина передзвонює, тепер уже через порушену обіцянку, а не через аварію.'
            },
            fx: { csat: -12 }
          }
        }
      ],
      principle: {
        en: 'Give what is owed now. Say what you cannot do plainly. Show the next door.',
        ua: 'Дай належне зараз. Прямо скажи, чого не можеш. Покажи наступні двері.'
      }
    },
    {
      type: 'choice',
      id: 's8',
      at: '15:45',
      comp: ['policy', 'empathy'],
      traits: ['C', 'S'],
      text: {
        en: 'In the team group chat Yana posts a screenshot of a customer\'s account: full name, address, phone, and his complaint text, with "look at this genius" underneath. Three people have already replied with laughing emojis.',
        ua: 'У груповому чаті команди Яна викладає скриншот картки клієнта: повне ім’я, адреса, телефон і текст його скарги, а внизу — «подивіться на цього генія». Троє вже відповіли смішками.'
      },
      options: [
        {
          text: {
            en: 'Write to Yana privately: delete it now, that is personal data in a chat with 20 people. Then tell the shift lead, because a leak has to be logged even if it is deleted.',
            ua: 'Написати Яні приватно: видали зараз, це персональні дані в чаті на 20 людей. Потім сказати старшому зміни, бо витік треба зафіксувати, навіть якщо його видалили.'
          },
          q: 'best',
          fx: { trust: 4, csat: 2 },
          fb: {
            en: 'Private first, so she can fix it without a public scene; the lead second, because the screenshot has been seen and the incident exists whether or not it is reported.',
            ua: 'Спершу приватно, щоб вона могла виправити без публічної сцени; потім старший, бо скриншот уже бачили, й інцидент існує незалежно від того, чи про нього повідомили.'
          }
        },
        {
          text: {
            en: 'Message Yana privately and ask her to delete it, and leave it there. She is new, she will get it, and dragging the lead in would make her an example.',
            ua: 'Написати Яні приватно з проханням видалити й на цьому зупинитися. Вона нова, зрозуміє, а тягнути старшого означало б зробити з неї показовий приклад.'
          },
          q: 'ok',
          fx: { trust: 1 },
          fb: {
            en: 'Kind to Yana, unkind to the customer whose address 20 people saw. Data incidents are reported so the company can act; your silence makes you part of it.',
            ua: 'По-доброму до Яни, недобре до клієнта, чию адресу побачили 20 людей. Про інциденти з даними повідомляють, щоб компанія могла діяти; твоє мовчання робить тебе частиною цього.'
          }
        },
        {
          text: {
            en: 'Reply in the chat that this is not okay and that she should know better, so that everyone sees the rule being enforced and nobody repeats it.',
            ua: 'Відповісти в чаті, що так не можна і що вона мала б знати, щоб усі бачили, що правило працює, і ніхто цього не повторив.'
          },
          q: 'bad',
          fx: { trust: -3 },
          fb: {
            en: 'The rule is enforced, Yana is humiliated in front of the team, and the screenshot is still there while people argue about tone.',
            ua: 'Правило працює, Яна принижена перед командою, а скриншот досі висить, поки всі сперечаються про тон.'
          }
        },
        {
          text: {
            en: 'Forward the screenshot to the shift lead as evidence so he can handle it, and say nothing in the chat to avoid drama in front of the team.',
            ua: 'Переслати скриншот старшому зміни як доказ, щоб він розібрався, і нічого не писати в чаті, щоб не влаштовувати драму перед командою.'
          },
          q: 'bad',
          fx: { trust: -5 },
          fb: {
            en: "You made a second copy of the customer's data to report a leak of it. Describe the incident; do not spread it.",
            ua: 'Ти зробив другу копію даних клієнта, щоб повідомити про їхній витік. Описуй інцидент, а не поширюй його.'
          }
        }
      ],
      principle: {
        en: 'A screenshot of a customer is a data incident, not a joke.',
        ua: 'Скриншот клієнта — інцидент із даними, а не жарт.'
      }
    },
    {
      type: 'allocate',
      id: 's9',
      at: '17:00',
      comp: ['priorities', 'accuracy'],
      traits: ['C', 'E'],
      text: {
        en: 'The queue is quiet for the last hour of the shift. Split the hour across what is left.',
        ua: 'Остання година зміни, черга тиха. Розподіли годину між тим, що лишилося.'
      },
      buckets: [
        {
          id: 'callbacks',
          label: { en: 'Promised callbacks', ua: 'Обіцяні передзвони' },
          hint: {
            en: 'Three customers were told "I will call you back today". Nobody else will.',
            ua: 'Трьом клієнтам ти сказав «передзвоню сьогодні». Більше ніхто не передзвонить.'
          },
          best: 35
        },
        {
          id: 'closing',
          label: { en: 'Closing resolved tickets', ua: 'Закриття вирішених тікетів' },
          hint: {
            en: 'Six fixed tickets are still open; at midnight each counts as an SLA breach.',
            ua: 'Шість полагоджених тікетів досі відкриті; опівночі кожен зарахується як порушення SLA.'
          },
          best: 30
        },
        {
          id: 'kb',
          label: { en: 'Knowledge-base article', ua: 'Стаття в базі знань' },
          hint: {
            en: 'The "red internet light" question came in 40 times this week; a good article cuts that by half.',
            ua: 'Питання про «червоний індикатор інтернету» прийшло 40 разів за тиждень; гарна стаття зріже це вдвічі.'
          },
          best: 20
        },
        {
          id: 'newbie',
          label: { en: 'Help the new colleague', ua: 'Допомога новому колезі' },
          hint: {
            en: 'He has four tickets he does not know how to answer.',
            ua: 'У нього чотири тікети, на які він не знає, як відповісти.'
          },
          best: 15
        }
      ],
      explain: {
        en: 'Promises to customers come first: a missed callback is a complaint tomorrow. Open-but-fixed tickets are free SLA points before midnight. The article pays back next week, not tonight, so it gets a solid but smaller share. The new colleague gets about 10 minutes, enough to unblock four tickets.',
        ua: 'Обіцянки клієнтам — перші: пропущений передзвін — це скарга завтра. Полагоджені, але відкриті тікети — безкоштовні бали SLA до півночі. Стаття окупиться наступного тижня, а не сьогодні, тому її частка менша, але суттєва. Новому колезі — близько 10 хвилин, достатньо, щоб розблокувати чотири тікети.'
      },
      fx: { ok: { sla: 4, csat: 3 }, fail: { sla: -4 } }
    }
  ],
  verdict: {
    bands: [
      {
        min: 0.8,
        title: {
          en: 'You could take the hardest line on day one',
          ua: 'Тобі можна давати найважчу лінію з першого дня'
        },
        text: {
          en: 'You checked the line before the script, told the truth with a workaround and treated a screenshot as the incident it is. That is senior support.',
          ua: 'Ти перевіряв лінію раніше за скрипт, казав правду разом з обхідним шляхом і сприйняв скриншот як інцидент, яким він і є. Це підтримка рівня сеньйора.'
        }
      },
      {
        min: 0.6,
        title: {
          en: 'Reliable agent who sometimes hides behind the script',
          ua: 'Надійний оператор, який іноді ховається за скриптом'
        },
        text: {
          en: 'Most answers were right; the misses came from doing the standard steps when the data already said what was wrong.',
          ua: 'Більшість відповідей правильні; промахи були там, де ти робив стандартні кроки, хоча дані вже казали, що не так.'
        }
      },
      {
        min: 0.4,
        title: {
          en: 'You would close tickets and lose customers',
          ua: 'Ти б закривав тікети і втрачав клієнтів'
        },
        text: {
          en: 'You tend to protect the queue and the policy more than the person on the line. Re-read the feedback on the exam call and the refund.',
          ua: 'Ти схильний захищати чергу і правила більше, ніж людину на лінії. Перечитай фідбек до дзвінка про іспит і до повернення грошей.'
        }
      },
      {
        min: 0,
        title: { en: 'This shift would have flattened you', ua: 'Ця зміна б тебе розплющила' },
        text: {
          en: 'Many choices ended the conversation fast and left the problem for the next agent. Support is the opposite: own it until it is solved or properly handed over.',
          ua: 'Багато рішень швидко закінчували розмову й лишали проблему наступному оператору. Підтримка — навпаки: веди справу, поки її не вирішено або правильно не передано.'
        }
      }
    ],
    reality: [
      {
        en: 'Around 60% of tickets are the same five problems. The job is answering the 40th "red light" question as if it were the first.',
        ua: 'Близько 60% тікетів — одні й ті самі п’ять проблем. Робота — відповідати на сорокове питання про «червоний індикатор» так, ніби воно перше.'
      },
      {
        en: 'Two or three people a shift will shout at you for something you did not break. You will still write a polite note afterwards.',
        ua: 'Двоє-троє людей за зміну кричатимуть на тебе через те, чого ти не ламав. Після цього ти все одно напишеш ввічливу нотатку.'
      },
      {
        en: "About an hour a day is tickets, notes and closures, not customers. Skip it and tomorrow's queue starts with yesterday's breaches.",
        ua: 'Приблизно година на день — це тікети, нотатки й закриття, а не клієнти. Пропустиш — і завтрашня черга почнеться з учорашніх порушень.'
      }
    ]
  }
};
